module.exports = __webpack_public_path__ + "static/media/11_r_stena_84.11_0.7e150acd.png";